import { Button, Css, ModalBody, ModalFooter, ModalHeader, useModal } from "@homebound/beam";
import { ReactNode, useCallback } from "react";

export type ConfirmationModalProps = {
  confirmationMessage: ReactNode | string;
  onConfirmAction: () => void;
  title: string;
  label: string;
  danger?: boolean;
  disabled?: boolean | ReactNode;
};

export function ConfirmationModal(props: ConfirmationModalProps) {
  const { confirmationMessage, onConfirmAction, title, label, danger, disabled } = props;
  const { closeModal } = useModal();

  const onConfirmClick = useCallback(async () => {
    await onConfirmAction();
    closeModal();
  }, [onConfirmAction, closeModal]);

  const renderBody = () => {
    if (typeof confirmationMessage === "string") {
      return <p css={Css.sm.gray900.mb2.$}>{confirmationMessage}</p>;
    } else {
      return confirmationMessage;
    }
  };

  return (
    <>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>{renderBody()}</ModalBody>
      <ModalFooter>
        <Button variant="quaternary" label="Cancel" onClick={closeModal} />
        <Button disabled={disabled} label={label} onClick={onConfirmClick} variant={!!danger ? "danger" : "primary"} />
      </ModalFooter>
    </>
  );
}
